/**
 * @fileoverview GET handler for the "/custom_objects/user_relationship_type_attributes" endpoint.
 * Returns the filterable attributes for a user custom object relationship type.
 */
import fetch from "@lib/fetch";

import { buildCustomObjectsQueryParams } from "../customObjectsShared/buildQueryParams";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsUserRelationshipTypeAttributes } from "./constants";
import type {
  GetCustomObjectsUserRelationshipTypeAttributesParams,
  GetCustomObjectsUserRelationshipTypeAttributesResult,
} from "./types";
import { isGetCustomObjectsUserRelationshipTypeAttributesResult } from "./validators";

export const getCustomObjectsUserRelationshipTypeAttributes = reactQueryFetcherAdapter(
  customObjectsUserRelationshipTypeAttributes,
  (
    signal: AbortSignal,
    params: GetCustomObjectsUserRelationshipTypeAttributesParams
  ): Promise<GetCustomObjectsUserRelationshipTypeAttributesResult> => {
    return fetch(
      "/custom_objects/user_relationship_type_attributes",
      "GET",
      buildCustomObjectsQueryParams(params),
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetCustomObjectsUserRelationshipTypeAttributesResult
);
